import data from "../../data.json";
import objectHash from "object-hash";

const NAMESPACE = "trtaSolutionFinder";
const PERSIST_KEY = "chosenSteps";
const PERSIST_HASH_KEY = `${PERSIST_KEY}:hash`;
const DATA_HASH = objectHash(data);

export const setLocalStorage = (key, val) => {
  window.localStorage.setItem(`${NAMESPACE}:${key}`, JSON.stringify(val));
};

export const getLocalStorage = key => {
  return JSON.parse(
    window.localStorage.getItem(`${NAMESPACE}:${key}`) || "null"
  );
};

export const getPersistedResults = () => {
  const hash = getLocalStorage(PERSIST_HASH_KEY);

  if (DATA_HASH === hash) {
    return getLocalStorage(PERSIST_KEY);
  }

  return null;
};

export const updatePersistedResults = results => {
  setLocalStorage(PERSIST_HASH_KEY, DATA_HASH);
  setLocalStorage(PERSIST_KEY, results);
};



// WEBPACK FOOTER //
// ./js/helpers/localStorage.js